import { useDispatch, useSelector } from 'react-redux';
import {
  setPageTitle as storePageTitle,
  setPageDescription as storePageDescription,
  setPageKeywords as storePageKeywords,
  setJsonItem as storeJsonItem,
  setCanonicalURL as storeCanonicalURL,
} from '../redux/legacy/reducers/ducks/new/Seo/SeoReducer';
import {
  selectPageTitle,
  selectPageDescription,
  selectPageKeywords,
  selectJsonItem,
  selectCanonicalUrl,
} from '../redux/legacy/reducers/ducks/new/Seo/SeoSelector';

export function useSeo() {
  const dispatch = useDispatch();

  const setPageTitle = (title: string | null) =>
    dispatch(storePageTitle(title));

  const setPageDescription = (description: string | null) =>
    dispatch(storePageDescription(description));

  const setPageKeywords = (description: string | null) =>
    dispatch(storePageKeywords(description));

  const setJsonItem = (item: any) => dispatch(storeJsonItem(item));

  const setCanonicalURL = (url: string) => dispatch(storeCanonicalURL(url));

  /**
   * Helper to generate a canonical URL for the current page.
   * Uses https in production, preserves protocol on localhost.
   */
  const getCanonicalForPath = (path?: string): string => {
    const { hostname, pathname } = window.location;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const protocol = isLocalhost ? window.location.protocol : 'https:';
    const targetPath = path ?? pathname;
    return `${protocol}//${hostname}${targetPath}`;
  };

  /**
   * Set canonical URL for current page path (or custom path).
   * Automatically uses https in production.
   */
  const setCanonicalForCurrentPage = (path?: string) => {
    dispatch(storeCanonicalURL(getCanonicalForPath(path)));
  };

  const reset = () => {
    dispatch(storePageTitle(null));
    dispatch(storePageDescription(null));
    dispatch(storePageKeywords(null));
    dispatch(storeJsonItem(null));
    dispatch(storeCanonicalURL(null));
  };

  const pageTitle = useSelector(selectPageTitle);
  const pageDescription = useSelector(selectPageDescription);
  const pageKeywords = useSelector(selectPageKeywords);
  const jsonItem = useSelector(selectJsonItem);
  const canonicalURL = useSelector(selectCanonicalUrl);

  return {
    pageTitle,
    pageDescription,
    pageKeywords,
    jsonItem,
    canonicalURL,
    setPageTitle,
    setPageDescription,
    setPageKeywords,
    setJsonItem,
    setCanonicalURL,
    setCanonicalForCurrentPage,
    getCanonicalForPath,
    reset,
  };
}

export default useSeo;
